module.exports = "label {\n    color: rgb(31, 112, 191)\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/register/register.component.css
// module id = ./src/app/register/register.component.css
// module chunks = main